
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/coreka",
      function () {
        return require("private-next-pages/cases/coreka/index.tsx");
      }
    ]);
  